<div class="relative flex flex-col min-w-0 break-words w-full">

    @let loading = (loading$ | async);
    @let isSearching = (isSearching$ | async);
    @let showingSearchResults = (showingSearchResults$ | async);

    <list-utils-bar (valueChanged)="onSearchTermChange($event)" [isSearching]="isSearching$"
        [showingResults]="showingSearchResults$" (onSearch)="onSearch($event)" (onCancel)="onCancelSearch()"
        (onRefresh)="onRefresh()"></list-utils-bar>

    @for (item of parents$ | async; track item.id) {
    <div #itemRef [attr.data-id]="item.id"
        class="bg-white shadow-lg rounded w-full p-4 mb-4 flex flex-row justify-between transition-colors duration-1000"
        [class.bg-yellow-400]="item.id === firstNewItemId">
        <div class="flex flex-row items-start flex-nowrap cursor-pointer" [routerLink]="['../parents', item.memberId]">
            @if (item.photoURL) {
            <img [src]="item.photoURL"
                class="bg-gray-100 min-h-10 max-h-10 max-w-10 min-w-10 object-cover rounded-full border-none" />
            } @else {
            <div
                class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center min-h-10 max-h-10 max-w-10 min-w-10 rounded-full">
                {{ item.name | initials }}
            </div>
            }
            <div class="flex flex-col px-3">
                <div class="flex-1 inline-flex flex-span text-sm font-bold text-blueGray-600">
                    <span>{{item.name ?? '' | titlecase }}</span>
                </div>
                <span class="text-sm text-primary-300 capitalize font-light">
                    Registered Children: {{ item.studentId?.length ?? '-'}}</span>
                <span class="text-xs text-primary-300 font-light whitespace-nowrap mt-2">
                    Joined: {{ item.created | moment: 'Do MMM YYYY' }}
                </span>
            </div>
        </div>
        <div class="flex flex-row gap-2 whitespace-nowrap">
            <app-btn-fab (click)="onViewProfile(item)" tooltip="View Profile" icon="fas fa-eye"></app-btn-fab>
            <app-btn-fab (click)="onAddStudent(item)" icon="fas fa-user-plus" tooltip="Add Child">
            </app-btn-fab>
            <app-btn-fab (click)="onAssignRole(item)" icon="fas fa-id-card-clip" tooltip="Change Role"></app-btn-fab>
            <app-change-member-status [item]="item"></app-change-member-status>
        </div>
    </div>
    } @empty {
    @if(!(loading || isSearching)) {
    <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
        No Parents Found
    </div>
    }
    @if(loading || isSearching) {
    <loading-member></loading-member>
    }
    }
</div>
@if (!(isSearching || showingSearchResults)) {
<div class="flex flex-row w-full justify-center px-4 mb-4 -mt-2">
    <app-btn-more (click)="addMore()" [isDisabled]="loading || ((isSearching$ | async) ?? false)"></app-btn-more>
</div>
}